import React from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { makeStyles } from "tss-react/mui";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";

const useStyles = makeStyles()({
  formContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    justifyContent: "left",
    width: "100%",
    padding: "0px 15px",
    textAlign: "left",
    minHeight: "250px",
    "& .Mui-disabled": {
      color: "#FFFFFF",
    },
    "& .MuiButtonBase-root:hover": {
      backgroundColor: "#2B8AAA",
    },
  },
});

export default function Mapping({
  email,
  setEmail,
  claimEmail,
  setClaimEmail,
  firstname,
  setFirstname,
  claimFirstname,
  setClaimFirstname,
  lastname,
  setLastname,
  claimLastname,
  setClaimLastname,
  claimValues,
}) {
  const { classes } = useStyles();

  return (
    <Box sx={{ width: "100%" }} component="form" className={classes.formContainer}>
      <Grid container spacing={2} style={{ marginTop: "10px" }}>
        <Grid size={6}>
          <TextField
            margin="dense"
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            label="Email ID"
            autoFocus
            value={email}
            required
          />
        </Grid>
        <Grid size={6}>
          <TextField
            margin="dense"
            fullWidth
            label="Attribute Claim"
            variant="outlined"
            value={claimEmail}
            onChange={(e) => setClaimEmail(e.target.value)}
            required
            select
          >
            {claimValues.map(({ value, name }) => (
              <MenuItem key={value} value={value}>
                {name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid size={6}>
          <TextField
            margin="dense"
            onChange={(e) => setFirstname(e.target.value)}
            fullWidth
            label="First Name"
            required
            value={firstname}
          />
        </Grid>
        <Grid size={6}>
          <TextField
            margin="dense"
            fullWidth
            label="Attribute Claim"
            variant="outlined"
            value={claimFirstname}
            onChange={(e) => setClaimFirstname(e.target.value)}
            required
            select
          >
            {claimValues.map(({ value, name }) => (
              <MenuItem key={value} value={value}>
                {name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid size={6}>
          <TextField
            margin="dense"
            onChange={(e) => setLastname(e.target.value)}
            fullWidth
            label="Last Name"
            required
            value={lastname}
          />
        </Grid>
        <Grid size={6}>
          <TextField
            margin="dense"
            fullWidth
            label="Attribute Claim"
            variant="outlined"
            value={claimLastname}
            onChange={(e) => setClaimLastname(e.target.value)}
            required
            select
          >
            {claimValues.map(({ value, name }) => (
              <MenuItem key={value} value={value}>
                {name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </Box>
  );
}
